module.exports = __webpack_public_path__ + "static/media/email_success.e2d63b1b.svg";